import { range } from '@udemy/shared-utils';
import classNames from 'classnames';
import React from 'react';
import { Block } from '../block/block.react-component';
import styles from "./course-card-skeleton-group.module.css";
import { CourseCardSkeleton } from './course-card-skeleton.react-component';
/** React props interface for the `CourseCardSkeletonGroup` component */

/**
 * ### The CourseCardSkeletonGroup component.
 *
 * @remarks
 * Renders several {@link CourseCardSkeleton} components.
 */
export const CourseCardSkeletonGroup = _ref => {
  let {
    className,
    cardCountPerRow: givenCardCountPerRow,
    cardWrapper: CardWrapper = React.Fragment,
    rowCount = 1,
    withTitle = false,
    ...cardSkeletonProps
  } = _ref;
  let cardCountPerRow = givenCardCountPerRow;

  if (!givenCardCountPerRow) {
    cardCountPerRow = cardSkeletonProps.size === 'small' ? 3 : 5;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.skeleton)
  }, withTitle && /*#__PURE__*/React.createElement(Block, {
    className: styles.title
  }), range(rowCount).map(i => /*#__PURE__*/React.createElement("div", {
    key: i,
    className: styles.row
  }, range(cardCountPerRow).map(j => /*#__PURE__*/React.createElement(CardWrapper, {
    key: j
  }, /*#__PURE__*/React.createElement(CourseCardSkeleton, cardSkeletonProps))))));
};
//# sourceMappingURL=course-card-skeleton-group.react-component.js.map